
var video_player = {
  players: {},
  init: () => {
    if ($('.video-player-box').length == 0) return;

    $('.video-player-box').each(function(i) {
      var _t = $(this);
      var player = $('.video-player', _t);
      var player_data = player.data();
      var player_params = $('> script', _t).text(),
          new_player_params = '';
      do {
        player_params = new_player_params || player_params;
        new_player_params = general.decodeEntity(player_params);
      } while (new_player_params != player_params);

      var videoObj = new VideoWorker(player_data.url, JSON.parse(player_params));
      if (videoObj.isValid()) {
        // youtube, vimeo
        videoObj.getVideo((video) => {
          var $parent = video.parentNode;
          player.html(video);
          $parent.parentNode.removeChild($parent);
        });
      } else {
        // html5
        videoObj = document.createElement('video');
        videoObj.src = player_data.url + '#t=0.001';
        videoObj.loop = true;
        player.get(0).appendChild(videoObj);
        videoObj.type = 'html5';
      }

      if (typeof player_data.id === 'undefined' || player_data.id == '') {
        player_data.id = `video-player-${i}`;
        player.attr('data-id', player_data.id);
      }
      video_player.players[player_data.id] = videoObj;

      _t.addClass('initialized');
    });

    $.each(video_player.players, function(i, videoObj) {
      if (videoObj.type == 'html5') {
        video_player.initEventHtml5(videoObj);
      } else {
        video_player.initEventWorker(videoObj);
      }
    });
  },
  // initOffline: () => {
  //   if ($('.video-player-box').length == 0) return;

  //   $('.video-player-box').each(function(i) {
  //     var _t = $(this);

  //     // if (_t.hasClass('initialized')) return;

  //     var player = $('.video-player', _t);
  //     var player_data = player.data();
  //     var player_params = $('> script', _t).text(),
  //         new_player_params = '';
  //     do {
  //       player_params = new_player_params || player_params;
  //       new_player_params = general.decodeEntity(player_params);
  //     } while (new_player_params != player_params);

  //     var videoObj = new VideoWorker(player_data.url, JSON.parse(player_params));
  //     if (videoObj.isValid()) {
  //       // youtube, vimeo
  //       // videoObj.getVideo((video) => {
  //       //   videoObj.fn = function() {
  //       //     var $parent = video.parentNode;
  //       //     player.html(video);
  //       //     // $parent.parentNode.removeChild($parent);
  //       //   }
  //       // });
  //     } else {
  //       // html5
  //       videoObj = document.createElement('video');
  //       videoObj.src = player_data.url + '#t=0.001';
  //       videoObj.loop = true;
  //       player.get(0).appendChild(videoObj);
  //       videoObj.type = 'html5';

  //       _t.addClass('initialized');
  //     }

  //     if (typeof player_data.id === 'undefined' || player_data.id == '') {
  //       player_data.id = `video-player-${i}`;
  //       player.attr('data-id', player_data.id);
  //     }
  //     video_player.players[player_data.id] = videoObj;
  //   });

  //   $.each(video_player.players, function(i, videoObj) {
  //     if (videoObj.type == 'html5') {
  //       video_player.initEventHtml5(videoObj);
  //     } else {
  //       // video_player.initEventWorker(videoObj);
  //     }
  //   });

  //   $('.video-player-box').on('click', function(e) {
  //     var _t = $(this);

  //     if (_t.hasClass('initialized')) return;

  //     var player = $('.video-player', _t);
  //     var player_data = player.data();
  //     var player_params = $('> script', _t).text(),
  //         new_player_params = '';
  //     do {
  //       player_params = new_player_params || player_params;
  //       new_player_params = general.decodeEntity(player_params);
  //     } while (new_player_params != player_params);

  //     var videoObj = new VideoWorker(player_data.url, JSON.parse(player_params));

  //     videoObj.getVideo((video) => {
  //       var $parent = video.parentNode;
  //       player.html(video);
  //       $parent.parentNode.removeChild($parent);
  //     });

  //     video_player.players[player_data.id] = videoObj;

  //     video_player.initEventWorker(videoObj);

  //     _t.addClass('initialized');
  //   });
  // },
  initEventHtml5: (videoObj) => {
    // play
    videoObj.addEventListener('play', (event) => {
      var obj = video_player.getVideoData($(event.target));

      obj.el_video.addClass('playing').removeClass('paused');
      obj.el_video.parent().addClass('playing').removeClass('paused');
      
      // video_player.players[obj.player_data.id].controls = true;

      $(document).trigger({
        type: 'video_worker_play',
        video: videoObj,
      });
    });

    // pause
    videoObj.addEventListener('pause', (event) => {
      var obj = video_player.getVideoData($(event.target));

      obj.el_video.removeClass('playing').addClass('paused');
      obj.el_video.parent().removeClass('playing').addClass('paused');

      // video_player.players[obj.player_data.id].controls = false;
      
      $(document).trigger({
        type: 'video_worker_pause',
        video: videoObj,
      });
    });

    // ended
    videoObj.on('ended', (event) => {
      $(document).trigger({
        type: 'video_worker_ended',
        video: videoObj,
      });
    });
  },
  initEventWorker: (videoObj) => {
    // play
    videoObj.on('play', (event) => {
      var obj = video_player.getVideoData($(videoObj.$video));

      obj.el_video.addClass('playing').removeClass('paused');
      obj.el_video.parent().addClass('playing').removeClass('paused');
      
      $(document).trigger({
        type: 'video_worker_play',
        video: videoObj,
      });
    });

    // pause
    videoObj.on('pause', (event) => {
      var obj = video_player.getVideoData($(videoObj.$video));
  
      obj.el_video.removeClass('playing').addClass('paused');
      obj.el_video.parent().removeClass('playing').addClass('paused');
      
      $(document).trigger({
        type: 'video_worker_pause',
        video: videoObj,
      });
    });

    // ended
    videoObj.on('ended', (event) => {
      $(document).trigger({
        type: 'video_worker_ended',
        video: videoObj,
      });
    });
  },
  getVideoData: (_t) => {
    var el_video = _t.parents('.video-player-box');
    var player = $('.video-player', el_video);
    var player_data = player.data();

    return {
      _t: _t,
      el_video: el_video,
      player: player,
      player_data: player_data,
    }
  },

  play: (_t) => {
    var obj = video_player.getVideoData(_t);
    if (typeof obj.player_data !== 'undefined' && typeof video_player.players[obj.player_data.id] !== 'undefined') {
      video_player.players[obj.player_data.id].play();
    }
  },

  pause: (_t) => {
    var obj = video_player.getVideoData(_t);
    if (typeof obj.player_data !== 'undefined' && typeof video_player.players[obj.player_data.id] !== 'undefined') {
      video_player.players[obj.player_data.id].pause();
    }
  },

  stop: (_t) => {
    var obj = video_player.getVideoData(_t);
    if (typeof obj.player_data !== 'undefined' && typeof video_player.players[obj.player_data.id] !== 'undefined') {
      video_player.players[obj.player_data.id].pause();
      video_player.players[obj.player_data.id].player.currentTime = 0;
    }
  },

  stopAll: () => {
    $('.video-player-box .video-player').each(function() {
      var obj = video_player.getVideoData($(this));
      if (typeof obj.player_data !== 'undefined' && typeof video_player.players[obj.player_data.id] !== 'undefined') {
        video_player.players[obj.player_data.id].pause();
        if (typeof video_player.players[obj.player_data.id].player !== 'undefined' && video_player.players[obj.player_data.id].player.hasOwnProperty('currentTime')) {
          video_player.players[obj.player_data.id].player.currentTime = 0;
        }
      }
    });
  },
}